enum MembershipTypeEnum {
  ADMIN = "ADMIN",
  STANDARD = "STANDARD",
  SILVER = "SILVER",
  BRONZE = "BRONZE",
}

export default MembershipTypeEnum;
